import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { startWith, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { isEqual } from 'lodash';

import { EventBusService } from '@core/services/event-bus.service';
import {
  FeaturesEventKinds,
  FeaturesEvents,
} from '@core/events/features.event';
import { FeaturesResearchModel } from '@shared/models/features-research.model';

import { Features } from '../DTO/features';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root',
})
export class FeaturesService {
  public features: Features = {};

  constructor(
    private httpClient: HttpClient,
    private configurationService: ConfigurationService,
    private eventBusService: EventBusService,
  ) {}

  private getBaseResourceEndpoint(): string {
    return this.configurationService.configuration.api.features;
  }

  clearFeatures() {
    this.features = {};
  }

  getFeatures(request: FeaturesResearchModel): Observable<Features> {
    return this.httpClient
      .post<Features>(`${this.getBaseResourceEndpoint()}/search`, request)
      .pipe(
        tap((features) => {
          if (!isEqual(features, this.features)) {
            this.eventBusService.emit(FeaturesEvents.updateFeatures(features));
          }
        }),
        tap((features) => (this.features = features))
      );
  }

  onFeaturesUpdate(): Observable<Features> {
    return this.eventBusService
      .on(FeaturesEventKinds.update)
      .pipe(
        startWith(this.features),
      );
  }
}
